import { IconButton, Slider, Tooltip } from "@mui/material";
import React, { useEffect, useMemo, useState } from "react";
import {
  Controller,
  FormProvider,
  useForm,
  useFormContext,
} from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { languageSelector } from "slices/languageSlice";
import { Select, selectCustomStyles } from "./common/Select";
import { fetchClientLanguages } from "slices/languageSlice";
import { fetchL } from "slices/languageSlice";
import ErrorMessage from "./common/ErrorMessage";
import useFacilitiesFeatured from "hooks/useFacilitiesFeatured";
import moment from "moment";
import { SubmitButton } from "./common/buttons/SubmitButton";
import { fetchVendors } from "slices/vendorSlice";
import { setError } from "slices/scheduleSlice";
import Checkbox from "./common/Checkbox";
import { AsyncPaginate } from "react-select-async-paginate";
import Swal from "sweetalert2";
import { fetchTypes } from "slices/typeSlice";
import { fetchFacilities } from "slices/facilitiesSlice";
import { fetchDepartments } from "slices/departmentsSlice";
import { fetchInterpreters } from "slices/interpreterSlice";
import { updateClientAppointment } from "slices/appointmentSlice";
import { addClientAppointment } from "slices/appointmentSlice";
import { fetchClientPinCodes } from "slices/appointmentSlice";
import toast from "react-hot-toast";
import { fetchAppointments } from "slices/appointmentSlice";
import { Link, useNavigate } from "react-router-dom";
import { appointmentsSelector } from "slices/appointmentSlice";
import { facilitiesSelector } from "slices/facilitiesSlice";
import { departmentsSelector } from "slices/departmentsSlice";
import { Spinner } from "reactstrap";
import { filterPatient } from "slices/appointmentSlice";
import { setDepartment } from "slices/departmentsSlice";
import { setFacilities } from "slices/facilitiesSlice";
import TagInput from "./TagInput";
import { fetchAppointmentView } from "slices/appointmentSlice";
import Api from "services/api";
import { setIframeUrl } from "slices/iframeSlice";

//#region OPTIONS ARRAYS
export const businessDivisionOptions = [
  { value: "Castell", label: "Castell" },
  { value: "Intermountain", label: "Intermountain" },
  { value: "Medical Group", label: "Medical Group" },
  { value: "Tellica", label: "Tellica" },
];

export const priorityLevelOptions = [
  { value: "Regular", label: "Regular" },
  { value: "High", label: "Higher Priority" },
  { value: "Low", label: "Lower Priority" },
];

export const encounterTypeOptions = [
  { value: "In Person", label: "In Person" },
  { value: "VRI", label: "VRI" },
  { value: "OPI", label: "OPI" },
  { value: "OPI On Demand", label: "OPI On Demand" },
];

export const encounterSourceOptions = [
  { value: "Revenue Cycle", label: "Revenue Cycle" },
  { value: "Service Hub", label: "Service Hub" },
  { value: "Telephonic", label: "Telephonic" },
  { value: "Manual", label: "Manual" },
  { value: "List", label: "List" },
  { value: "Other", label: "Other" },
];

export const jobTypesOptions = [
  { value: "Assign", label: "Assign" },
  { value: "Escalation", label: "Escalation" },
  { value: "Open", label: "Open" },
];

export const statusOptions = [
  { value: "Billed", label: "Billed" },
  { value: "Dispute", label: "Dispute" },
  { value: "Paid", label: "Paid" },
];

export const economicServiceOptions = [
  { value: "Yes", label: "Yes" },
  { value: "No", label: "No" },
];
export const appointmentTypeOptions = [
  { value: "on_demand", label: "On Demand" },
  { value: "schedule", label: "Schedule" },
];

export const languageSelectionOptions = [
  { value: "spanish", label: "Spanish" },
  { value: "arabic", label: "Arabic" },
  { value: "cantonese", label: "Cantonese" },
  { value: "burmese", label: "Burmese" },
  { value: "maya", label: "Maya" },
  { value: "vietnamese", label: "Vietnamese" },
  { value: "navajo", label: "Navajo" },
  { value: "mixteco", label: "Mixteco" },
  { value: "french", label: "French" },
];


const ClientScheduleForm = ({
  handleClose,
  item,
  afterUpdated,
  callBack,
  isDuplicate = false,
  itsBootstrap = true,
  isNew = false,
  append = false,
  values,
}) => {
  console.log("itemsss", item);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { clientLanguage: languages, loadingLanguage } =
    useSelector(languageSelector);
  const { facilities } = useSelector(facilitiesSelector);
  const { departments } = useSelector(departmentsSelector);

  const methods = useForm({
    defaultValues: {
      appointment_type: "on_demand",
      priority_level: "Regular",
      duration: 15,
      date: moment(new Date()).format("YYYY-MM-DD"),
      start_time: moment(new Date()),
      comments: "Other",
      type: encounterTypeOptions[1].value,
      economic_services: "",
    },
  });
  const defaultLangauge = "Spanish";

    useEffect(() => {
        dispatch(fetchClientLanguages(1, {}, true));
    }, [dispatch])

  const {
    setFocus,
    handleSubmit,
    watch,
    formState: { errors },
    control,
    setValue,
    setError: setErrors,
    clearErrors,
    getValues,
  } = methods;
    console.log('languagesss ', languages);

  const currentLanguages = watch("appointment_type") === "on_demand" ? languages?.onDemand || [] : languages?.preScheduled || [];
  const { error, appointments: scheduleLists, clientpincodes } =
    useSelector(appointmentsSelector);
  const [loaderState, setLoaderState] = React.useState(false);
  const [mrnLoader, setMrnLoader] = React.useState(false);
  const submittingTypeRef = React.useRef(null);

  //#region  CLEAR UP ALL FIELDS
  const clearAllFields = React.useCallback(() => {
    setValue("account_id", "");
    setValue("interpreter_id", "");
    setValue("type", "VRI");
    setValue("date", moment(new Date()).format("YYYY-MM-DD"));
    setValue("start_time", moment().format("HH:mm"));
    setValue("language_id", "");
    setValue("duration", 15);
    setValue("vendor_id", "");
    setValue("requester_name", "");
    setValue("requester_phone", "");
    setValue("requester_email", []);
    setValue("facility_id", "");
    setValue("address", "");
    setValue("department_id", "");
    setValue("patient_phone", "");
    setValue("special_instruction", "");
    setValue("encounter_source", "");
    setValue("priority_level", "Regular");
    setValue("mrn_number", "");
    setValue("patient_name", "");
    setValue("birth_date", "");
    setValue("provider_name", "");
    setValue("medicaid_id", "");
    setValue("medicaid_plan", "");
    setValue("checkin_date", "");
    setValue("checkin_time", "");
    setValue("checkout_date", "");
    setValue("checkout_time", "");
    setValue("comments", "Other");
    setValue("notes", "");
    clearErrors();
    dispatch(setError({}));
  }, []);
  //#endregion

  useEffect(() => {
    dispatch(fetchClientPinCodes());
  }, [])

  const pinCodeOptions = useMemo(() => {
    if (!Array.isArray(clientpincodes)) return [];
    return clientpincodes.map(pin => ({ value: pin.code, label: pin.code + " " +pin.name }));
  }, [clientpincodes]);

  //#region useEffects
  React.useEffect(() => {
    const birth_date = item?.appointment_details?.patient?.birth_date;

    setValue("language_id", item?.language_id || "");
    setValue("date", item?.date || moment(new Date()).format("YYYY-MM-DD"));
    setValue("start_time", item?.start_time || moment().format("HH:mm"));
    setValue("account_id", item?.account_id || "");

    if (item?.account_id) {
      dispatch(
        fetchFacilities(1, {
          user_id: item?.account_id,
          pageLength: 1000,
          sortBy: "id",
          sortDirection: "asc",
        })
      );
    }

    setValue("facility_id", item?.appointment_details?.facility_id || "");
    setValue("department_id", item?.appointment_details?.department_id || "");
    setFilterDepartments({
      label: item?.appointment_details?.department?.department_name || "",
      value: item?.appointment_details?.department?.id || "",
    });
    setValue(
      "special_instruction",
      item?.appointment_details?.special_instruction || ""
    );
    setValue("duration", item?.duration || 15);
    setValue(
      "priority_level",
      item?.appointment_details?.priority_level || "Regular"
    );

    setValue(
      "mrn_number",
      item?.appointment_details?.patient?.mrn_number || ""
    );
    setValue(
      "patient_name",
      item?.appointment_details?.patient?.patient_name || ""
    );
    console.log("birth_date", birth_date);
    setValue(
      "birth_date",
      birth_date ? moment(new Date(birth_date)).format("YYYY-MM-DD") || "" : ""
    );
    setValue(
      "medicaid_id",
      item?.appointment_details?.patient?.medicaid_id || ""
    );
    setValue(
      "medicaid_plan",
      item?.appointment_details?.patient?.medicaid_plan || ""
    );
    setValue("type", item?.appid ? item?.type : encounterTypeOptions[1].value);
    setValue(
      "encounter_source",
      item?.appointment_details?.encounter_source || ""
    );
    setValue("requester_name", item?.appointment_details?.requester_name || "");
    setValue(
      "requester_phone",
      item?.appointment_details?.requester_phone || ""
    );
    setValue(
      "requester_email",
      item?.appointment_details?.requester_email || []
    );
    setValue("interpreter_id", item?.interpreter_id || "");
    setValue("vendor_id", item?.vendor_id || "");
    setValue("provider_name", item?.appointment_details?.provider_name || "");
    setValue(
      "requester_pin_code",
      item?.appointment_details?.requester_pincode || ""
    );
    setValue(
      "economic_services",
      item?.appointment_details?.requester_economic_service || ""
    );
    setValue(
      "appointment_type",
      item?.appointment_details?.appointment_type || "on_demand"
    );
    setValue("selected_language", item?.language_id || "");

    setValue("checkin_date", item?.appointment_assign?.checkin_date || "");
    setValue("checkin_time", item?.appointment_assign?.checkin_time || "");
    setValue("checkout_date", item?.appointment_assign?.checkout_date || "");
    setValue("checkout_time", item?.appointment_assign?.checkout_time || "");
    setValue("comments", item?.appointment_assign?.comments || "Other");
    setValue("notes", item?.appointment_assign?.notes || "");
  }, [item?.appid]);
  //#endregion

  //#region FETCH MRN NUMBER
  const fetchMRN = React.useCallback(() => {
    if (!watch("mrn_number")) {
      clearErrors("mrn_number");
      setValue("patient_name", "");
      setValue("birth_date", "");
      setValue("provider_name", "");
      setValue("medicaid_id", "");
      setValue("medicaid_plan", "");
      return;
    }
    clearErrors("mrn_number");
    const callback = (success, values) => {
      if (success) {
        setValue("patient_name", values?.patient_name);
        setValue("birth_date", values?.birth_date);
        setValue("provider_name", values?.provider_name);
        setValue("medicaid_id", values?.medicaid_id);
        setValue("medicaid_plan", values?.medicaid_plan);

        clearErrors("mrn_number");
        clearErrors("patient_name");
        clearErrors("birth_date");
        clearErrors("provider_name");
        clearErrors("medicaid_id");
        clearErrors("medicaid_plan");
      } else {
        setErrors("mrn_number", {
          message:
            "There is no Patient Available on this MRN, please create a new one",
        });
      }
    };
    dispatch(filterPatient({ mrn_number: watch("mrn_number") }, callback));
  }, [watch("mrn_number")]);
  //#endregion

  useEffect(() => {
    // setValue('facility_id', facilities?.find(i => i?.id === watch('facility_id'))?.id || '')
    // setValue('department_id', departments?.find(i => i?.id === watch('department_id'))?.id || '')
  }, [watch("facility_id"), watch("department_id")]);

  //#region SUBMIT FORM
  const submitCallback = async (status, message, data) => {
    console.log("id", data?.id);
    if (status) {
      const wasOnDemand = submittingTypeRef.current === "on_demand";
      clearAllFields();
      handleClose();
      setLoaderState(false);

      if (wasOnDemand) {
        toast.success("Appointment created. Joining video call...", {
          className: "successToast",
        });
        try {
          const response = await Api.clientJoinVideoCall(data?.id);
          if (response?.status === 200) {
            const iframeUrl = response?.data?.data?.iframe_url;
            dispatch(setIframeUrl(iframeUrl));
            navigate(`/user/appointments/view/${data?.id}/join-room-call`);
          } else {
            const errorMsg =
              response?.data?.message ||
              response?.data?.error ||
              "Failed to join video call.";
            toast.error(errorMsg, { className: "errorToast" });
            navigate(`/user/appointments/view/${data?.id}`);
          }
        } catch (err) {
          toast.error("Error joining video call.", { className: "errorToast" });
          navigate(`/user/appointments/view/${data?.id}`);
        }
      } else {
        toast.success(message, {
          className: "successToast",
        });
        Swal.fire({
          title: "Success!",
          text: message,
          icon: "success",
        }).then(() => {
          dispatch(fetchAppointmentView(data?.id));
          navigate(`/user/appointments/view/${data?.id}`);
        });
      }
    } else {
      console.log("onSubmit", error);
      toast.error(message, {
        className: "errorToast",
      });
      setTimeout(() => {
        setLoaderState(false);
      }, 1000);
    }
  };

  const onSubmit = React.useCallback(
    (data) => {
      dispatch(setError({}));
      setLoaderState(true);

      // Fix requester_email to be always an array
      if (typeof data.requester_email === "string") {
        try {
          data.requester_email = JSON.parse(data.requester_email);
          if (!Array.isArray(data.requester_email)) {
            data.requester_email = [];
          }
        } catch {
          data.requester_email = data.requester_email
            ? data.requester_email.split(",").map((email) => email.trim())
            : [];
        }
      }

      if (data.appointment_type === "on_demand") {
        data.date = moment().format("YYYY-MM-DD");
        data.start_time = moment().format("HH:mm");
      }

      submittingTypeRef.current = data.appointment_type;

      // Your rest of validations and submission
      if (data?.interpreter_id) {
        if (data?.checkin_date && !data?.checkin_time) {
          setErrors("checkin_time", { message: "Please select checkin time" });
          return;
        }
        if (data?.checkout_date && !data?.checkout_time) {
          setErrors("checkout_time", {
            message: "Please select checkout time",
          });
          return;
        }
      }
      if (item?.id && !isDuplicate) {
        dispatch(updateClientAppointment(data, item?.id, submitCallback, true));
      } else {
        dispatch(addClientAppointment(data, submitCallback, true));
      }
    },
    [item, callBack, append, isNew, isDuplicate, values, watch("date")]
  );

  const scrollToError = (fieldName) => {
    const element = document.querySelector(`[name="${fieldName}"]`);
    if (element) {
      const parentContainer = document.querySelector("#scheduleEncounter"); // Replace with your container class
      if (parentContainer) {
        const offsetTop = element.offsetTop - parentContainer.offsetTop;
        parentContainer.scrollTo({
          top: offsetTop,
          behavior: "smooth",
        });
      }
      // element.scrollIntoView({ behavior: "smooth", block: "center" });
      setFocus(fieldName); // Focus the field
    }
  };

  const onError = (error) => {
    const firstErrorField = Object.keys(error)[0];
    if (firstErrorField) scrollToError(firstErrorField);
  };

  //#endregion

  const account_id = watch("account_id");

  const handleFacDepChange = () => {
    setfilterFacilities({});
    setFilterDepartments(null);
    setValue("facility_id", null);
    setValue("department_id", null);
  };

  useEffect(() => {
    setValue(
      "address",
      facilities?.find((i) => i?.id === watch("facility_id"))?.address
    );
  }, [facilities, watch("facility_id"), setValue]);

  const isVendor = useMemo(() => {
    return watch("vendor_id") ? true : false;
  }, [watch("vendor_id")]);

  const isInterpreter = useMemo(() => {
    return watch("interpreter_id") ? true : false;
  }, [watch("interpreter_id")]);

  // #region language dropdown
  const [filterLanguages, setfilterLanguages] = useState({
    label: "",
    value: "",
  });

  useEffect(() => {
    if (item?.language?.name && item?.language?.id) {
      setfilterLanguages({
        label: item?.language?.name || "",
        value: item?.language?.id || "",
      });
    } else {
      const fetchData = async () => {
        try {
          const result = await dispatch(
            fetchClientLanguages(1, { search: defaultLangauge }, true, true)
          );
          const defaultLang = result?.data[0];
          setValue("language_id", defaultLang?.id);
          setfilterLanguages({
            label: defaultLang?.name,
            value: defaultLang?.id,
          });
        } catch (err) {
          console.error("Error fetching languages:", err);
        }
      };

      fetchData();
    }
  }, [item?.language, defaultLangauge]);

  // #region client dropdown
  const [filterClients, setfilterClients] = useState({
    label: "",
    value: "",
  });

  useEffect(() => {
    setfilterFacilities({});

    if (!filterClients.value) dispatch(setFacilities([]));
    dispatch(setDepartment([]));
  }, [filterClients]);

  const filteredLanguageLoadOptions = async (
    inputValue,
    loadedOptions,
    { page }
  ) => {
    const result = await dispatch(
      fetchClientLanguages(
        page,
        {
          pageLength: 20,
          sortBy: "id",
          sortDirection: "asc",
          search: inputValue,
        },
        true,
        true
      )
    );
    return {
      options: result.data.map((val) => ({
        value: val.id,
        label: val.name,
      })),

      hasMore: page !== result?.last_page,
      additional: {
        page: page + 1,
      },
    };
  };

  //#endregion

  // facilities = filterClients && filterClients.label === "" && filterClients.value === "" ? [] : facilities;

  useEffect(() => {
    if (item?.accounts?.user?.name && item?.accounts?.user?.id) {
      setfilterClients({
        label: item?.accounts?.user?.name || "",
        value: item?.accounts?.user?.id || "",
      });
    } else {
      setfilterClients({
        label: "",
        value: "",
      });
    }
  }, [item?.accounts?.user]);

  const filteredClientsLoadOptions = async (
    inputValue,
    loadedOptions,
    { page }
  ) => {
    const result = await dispatch(
      fetchTypes(
        page,
        {
          pageLength: 20,
          sortBy: "id",
          sortDirection: "asc",
          search: inputValue,
        },
        true,
        true
      )
    );
    return {
      options: result.data.map((val) => ({
        value: val.id,
        label: val.name,
      })),

      hasMore: page !== result?.last_page,
      additional: {
        page: page + 1,
      },
    };
  };
  //#endregion

  // #region Facility dropdown
  const [filterFacilities, setfilterFacilities] = useState({});

  const filteredFacilities = React.useMemo(() => {
    return (
      facilities?.map((item) => ({
        label: item?.abbreviation,
        value: item?.id,
      })) || []
    );
  }, [facilities]);

  const [filterDepartments, setFilterDepartments] = useState({});

  useEffect(() => {
    if (item?.department?.name && item?.department?.id) {
      setFilterDepartments({
        label: item?.department?.department_name || "",
        value: item?.department?.id || "",
      });
    }
  }, [item?.department]);

  const filteredDepartmentsLoadOptions = async (
    inputValue,
    loadedOptions,
    { page }
  ) => {
    const result = await dispatch(
      fetchDepartments(
        page,
        {
          user_id: account_id,
          pageLength: 20,
          sortBy: "id",
          sortDirection: "asc",
          search: inputValue,
        },
        true,
        true
      )
    );
    return {
      options: result.data.map((val) => ({
        value: val.id,
        label: val.department_name,
      })),

      hasMore: page !== result?.last_page,
      additional: {
        page: page + 1,
      },
    };
  };

  //#endregion

  // #region vendordropdown
  const [filterVendor, setFilterVendors] = useState({
    label: "",
    value: "",
  });

  useEffect(() => {
    if (item?.vendor?.name && item?.vendor?.id) {
      setFilterVendors({
        label: item?.vendor?.name || "",
        value: item?.vendor?.id || "",
      });
    } else {
      setFilterVendors(null);
    }
  }, [item?.vendor]);

  const filteredVendorLoadOptions = async (
    inputValue,
    loadedOptions,
    { page }
  ) => {
    const result = await dispatch(
      fetchVendors(
        page,
        {
          pageLength: 20,
          sortBy: "id",
          sortDirection: "asc",
          search: inputValue,
        },
        true,
        true
      )
    );
    return {
      options: result.data.map((val) => ({
        value: val.id,
        label: val.name,
      })),

      hasMore: page !== result?.last_page,
      additional: {
        page: page + 1,
      },
    };
  };
  //#endregion

  // #region Interpreter Dropdown
  const [filterInterpreters, setFilterInterpreters] = useState({
    label: "",
    value: "",
  });

  useEffect(() => {
    if (item?.interpreter?.first_name && item?.interpreter?.id) {
      setFilterInterpreters({
        label: item?.interpreter?.first_name || "",
        value: item?.interpreter?.id || "",
      });
    } else {
      setFilterInterpreters(null);
    }
  }, [item?.interpreter]);

  const filteredInterpretersLoadOptions = async (
    inputValue,
    loadedOptions,
    { page }
  ) => {
    const result = await dispatch(
      fetchInterpreters(
        page,
        {
          pageLength: 20,
          sortBy: "id",
          sortDirection: "asc",
          search: inputValue,
        },
        true,
        true
      )
    );
    return {
      options: result.data.map((val) => ({
        value: val.id,
        label: val.first_name,
      })),

      hasMore: page !== result?.last_page,
      additional: {
        page: page + 1,
      },
    };
  };
  //#endregion

  return (
    <FormProvider {...methods}>
      <form>
        {/* INPUTS */}
        <>


        <div className="row-primary">
            {/* <h2>Appointment Date & Time *</h2> */}
            <Controller
              name="appointment_type"
              control={control}
              render={({ field }) => {
                const selectedValue = field.value;
                return (
                  <div className="content Tabs_content" style={{ width: "100%" }}>
                    <div className="nav_tab_area" style={{ margin: "auto", background: "#e3e6e9" }}>
                      {appointmentTypeOptions.map((option) => (
                        <div
                          key={option.value}
                          onClick={() => field.onChange(option.value)}
                          onBlur={field.onBlur}
                              className={`tabLink main_button ${field.value === option.value ? "active" : ""}`}
                              style={{ cursor: "pointer" }}
                        >
                          {option.label}
                        </div>
                      ))}
                    </div>
                    {errors?.appointment_type?.message && (
                      <div style={{ marginBottom: 10 }}>
                        <ErrorMessage text={errors?.appointment_type?.message} />
                      </div>
                    )}
                    {error?.errors?.appointment_type?.map((error) => (
                      <div style={{ marginBottom: 10 }}>
                        <ErrorMessage text={error} />
                      </div>
                    ))}
                  </div>
                );
              }}
            />
        </div>
                  
          {/* LANGUAGE SELECT */}
          {/* <div className="row-primary">
            <h2>Language *</h2>
            <div className="w-100">
              <Controller
                name="language_id"
                control={control}
                rules={{
                  required: "Please select a language",
                }}
                render={({ field }) => (
                  <div style={{ width: "100%" }}>
                    <AsyncPaginate
                      menuPlacement="auto"
                      styles={{
                        ...selectCustomStyles,
                      }}
                      value={filterLanguages}
                      loadOptions={filteredLanguageLoadOptions}
                      isClearable
                      escapeClearsValue
                      onChange={(obj) => {
                        if (obj?.value) {
                          setfilterLanguages(obj);
                          field.onChange(obj.value);
                        } else {
                          setfilterLanguages(null);
                          field.onChange(null);
                        }
                      }}
                      additional={{
                        page: item?.state?.id ? 2 : 1,
                      }}
                    />
                    {errors?.language_id?.message && (
                      <div style={{ marginBottom: 10 }}>
                        <ErrorMessage text={errors?.language_id?.message} />
                      </div>
                    )}
                  </div>
                )}
              />
            </div>
          </div> */}

          {/* DATE TIME INPUT - Show only if appointment_type is 'schedule' */}
          {watch("appointment_type") === "schedule" && (
            <DateTimeInputs isDuplicate={isDuplicate} isNew={isNew} />
          )}

          {/* LANGUAGE SELECTION */}
          <div className="row-primary">
            <h2>Select Language *</h2>
            <div style={{ display: "flex", flexWrap: "wrap", gap: "10px"}}>
              <Controller
                name="selected_language"
                control={control}
                rules={{
                  required: "Please select a language",
                }}
                render={({ field }) => {
                  return currentLanguages?.map((opt) => (
                    <button
                      key={opt.id}
                      type="button"
                          onClick={() => {
                            field.onChange(opt.id);
                            setValue('language_id', opt.id);
                          }}
                          className={`${field.value === opt.id ? "main_button" : "main_button unactive"}`}
                    >
                      {opt.name}
                    </button>
                  ));
                }}
              />
            </div>
            {errors?.selected_language?.message && (
              <div style={{ marginBottom: 10 }}>
                <ErrorMessage text={errors?.selected_language?.message} />
              </div>
            )}
          </div>
          {/* <div className="row-primary">
            <h2>Client *</h2>
            <div className="w-100">
              <Controller
                name="account_id"
                control={control}
                rules={{
                  required: "Please select a client",
                }}
                render={({ field }) => (
                  <div style={{ width: "100%" }}>
                    <AsyncPaginate
                      menuPlacement="auto"
                      styles={{
                        ...selectCustomStyles,
                      }}
                      value={filterClients}
                      loadOptions={filteredClientsLoadOptions}
                      isClearable
                      escapeClearsValue
                      onChange={(obj) => {
                        if (obj?.value) {
                          setfilterClients(obj);
                          field.onChange(obj.value);
                          handleFacDepChange();
                          // dispatch(setDepartment())
                          dispatch(
                            fetchFacilities(1, {
                              user_id: obj.value,
                              pageLength: 1000,
                              sortBy: "id",
                              sortDirection: "asc",
                            })
                          );
                          // dispatch(fetchDepartments(1, { user_id: obj.value, pageLength: 1000, sortBy: "id", sortDirection: "asc" }));
                        } else {
                          handleFacDepChange();
                          setfilterClients({
                            label: "",
                            value: "",
                          });
                          setfilterFacilities({});
                          window.localStorage.removeItem("facilities");
                          field.onChange(null);
                          console.log("Client unselected");
                        }
                      }}
                      additional={{
                        page: item?.state?.id ? 2 : 1,
                      }}
                    />
                    {errors?.account_id?.message && (
                      <div style={{ marginBottom: 10 }}>
                        <ErrorMessage text={errors?.account_id?.message} />
                      </div>
                    )}
                  </div>
                )}
              />
            </div>
          </div> */}

          {/* FACILITY SELECT */}
          {/* <div className="row-primary">
            <h2>Facility Name *</h2>
            <div className="w-100">
              <Controller
                name="facility_id"
                control={control}
                rules={{
                  required: "Please select a facility",
                }}
                render={({ field }) => (
                  <div style={{ width: "100%" }}>
                    <Select
                      menuPlacement="auto"
                      styles={{ ...selectCustomStyles }}
                      value={filteredFacilities.find(
                        (f) => f.value === field.value
                      )}
                      options={filteredFacilities}
                      isClearable
                      onChange={(obj) => {
                        if (obj) {
                          field.onChange(obj);
                          const selectFacility = facilities?.find(
                            (i) => i?.id === obj
                          );
                          console.log(selectFacility, "selectFacility");

                          setfilterFacilities({
                            label: selectFacility?.abbreviation,
                            value: selectFacility?.id,
                          });
                          dispatch(
                            fetchDepartments(1, {
                              facility_id: selectFacility?.id,
                              pageLength: 1000,
                              sortBy: "id",
                              sortDirection: "asc",
                            })
                          );
                        } else {
                          setfilterFacilities({
                            label: "",
                            value: "",
                          });
                          field.onChange(null);
                        }
                      }}
                    />
                    {errors?.facility_id?.message && (
                      <div style={{ marginBottom: 10 }}>
                        <ErrorMessage text={errors?.facility_id?.message} />
                      </div>
                    )}
                  </div>
                )}
              />
            </div>
          </div> */}

          {/* FACILITY ADDRESS */}
          {/* <div className="row-primary">
            <h2>Facility Address</h2>
            <Controller
              name="address"
              control={control}
              disabled
              render={({ field }) => (
                <input
                  className="input-in type_inp"
                  type="text"
                  name="address"
                  placeholder="Facility Address"
                  {...field}
                />
              )}
            />
          </div> */}

          {/* DEPARTMENT SELECT */}
          {/* <div className="row-primary">
            <h2>Department Name *</h2>
            <div className="w-100">
              <Controller
                name="department_id"
                control={control}
                rules={{
                  required: "Please select a department",
                }}
                render={({ field }) => (
                  <div style={{ width: "100%" }}>
                    <Select
                      menuPlacement="auto"
                      styles={{ ...selectCustomStyles }}
                      value={filterDepartments}
                      options={departments.map((i) => ({
                        label: i.department_name || "",
                        value: i.id || "",
                      }))}
                      isClearable
                      onChange={(obj) => {
                        if (obj) {
                          field.onChange(obj);

                          const selectDepartment = departments?.find(
                            (i) => i?.id === obj
                          );
                          setFilterDepartments({
                            label: selectDepartment?.department_name,
                            value: selectDepartment?.id,
                          });
                        } else {
                          setFilterDepartments(null);
                          field.onChange(null);
                        }
                      }}
                    />
                    {errors?.department_id?.message && (
                      <div style={{ marginBottom: 10 }}>
                        <ErrorMessage text={errors?.department_id?.message} />
                      </div>
                    )}
                  </div>
                )}
              />
            </div>
          </div> */}


          {/* DURATION */}
          {/* <DurationRange control={control} /> */}

          {/* Priority Level */}
          {/* <PriorityLevel control={control} errors={errors} /> */}

          {/* MRN NUMBER */}
          {/* <div className="row-primary">
            <h2>MRN Number *</h2>

            <Controller
              name="mrn_number"
              control={control}
              rules={{
                required: "MRN number is required",
              }}
              disabled={mrnLoader}
              render={({ field }) => (
                <div style={{ width: "100%" }}>
                  <div className="input-image">
                    <input
                      id="mrn_number"
                      type="text"
                      name="mrn_number"
                      // className="input-in type_inp"
                      placeholder="MRN Number"
                      {...field}
                      disabled={mrnLoader}
                    />

                    <Tooltip title="Click to get Patient Details">
                      <IconButton
                        type="button"
                        aria-label="delete"
                        disabled={!watch("mrn_number") || mrnLoader}
                        onClick={fetchMRN}
                      >
                        {mrnLoader ? (
                          <Spinner size={"sm"} color="primary" type="grow" />
                        ) : (
                          <h2
                            style={{
                              color: "#777682",
                              minWidth: "auto",
                              marginTop: 0,
                            }}
                            onPress={fetchMRN}
                          >
                            Fetch
                          </h2>
                        )}
                      </IconButton>
                    </Tooltip>
                  </div>
                  {errors?.mrn_number?.message && (
                    <div style={{ marginBottom: 10 }}>
                      <ErrorMessage text={errors?.mrn_number?.message} />
                    </div>
                  )}
                </div>
              )}
            />
          </div> */}

          {/* PATIENT NAME */}
          {/* <div className="row-primary">
            <h2>Patient Name *</h2>
            <Controller
              name="patient_name"
              control={control}
              rules={{
                required: "Patient name is required",
              }}
              render={({ field }) => (
                <div style={{ width: "100%" }}>
                  <input className="input-in type_inp" type="text" {...field} />

                  {errors?.patient_name?.message && (
                    <div style={{ marginBottom: 10 }}>
                      <ErrorMessage text={errors?.patient_name?.message} />
                    </div>
                  )}
                </div>
              )}
            />
          </div> */}

          {/* BIRTH DATE */}
          {/* <div className="row-primary">
            <h2>Birth Date *</h2>
            <Controller
              name="birth_date"
              control={control}
              rules={{
                required: "Birth date is required",
              }}
              render={({ field }) => (
                <div style={{ width: "100%" }}>
                  <div className="input-image">
                    <input
                      id="birth_date"
                      type="date"
                      name="birth_date"
                      placeholder="YYYY-MM-DD"
                      {...field}
                      value={field.value ? field?.value : ""}
                      onPaste={(e) => {
                        e.preventDefault(); // Prevent default paste behavior
                        const pastedData = e.clipboardData.getData("text"); // Get pasted text
                        const dateString = moment
                          .utc(pastedData)
                          .format("YYYY-MM-DD");

                        if (moment(dateString, "YYYY-MM-DD", true).isValid()) {
                          field.onChange(dateString);
                        } else {
                          console.warn("Invalid date format");
                        }
                      }}
                      onChange={(e) => {
                        const dateString = moment
                          .utc(e.target.value)
                          .format("YYYY-MM-DD");
                        field.onChange(dateString);
                      }}
                    />
                    <img
                      src="/images/celender.png"
                      alt="celender Icon"
                      className="custom-icon"
                    />
                  </div>
                  {errors?.birth_date?.message && (
                    <div style={{ marginBottom: 10 }}>
                      <ErrorMessage text={errors?.birth_date?.message} />
                    </div>
                  )}
                </div>
              )}
            />
          </div> */}

          {/* MEDICAID ID */}
          {/* <div className="row-primary">
            <h2>Medicaid ID#</h2>
            <Controller
              name="medicaid_id"
              control={control}
              render={({ field }) => (
                <div style={{ width: "100%" }}>
                  <input className="input-in type_inp" type="text" {...field} />
                  {errors?.medicaid_id?.message && (
                    <div style={{ marginBottom: 10 }}>
                      <ErrorMessage text={errors?.medicaid_id?.message} />
                    </div>
                  )}
                </div>
              )}
            />
          </div> */}

          {/* MEDICAID PLAN */}
          {/* <div className="row-primary">
            <h2>Medicaid Plan</h2>
            <Controller
              name="medicaid_plan"
              control={control}
              render={({ field }) => (
                <div style={{ width: "100%" }}>
                  <input className="input-in type_inp" type="text" {...field} />
                  {errors?.medicaid_plan?.message && (
                    <div style={{ marginBottom: 10 }}>
                      <ErrorMessage text={errors?.medicaid_plan?.message} />
                    </div>
                  )}
                </div>
              )}
            />
          </div> */}

          {/* ENCOUNTER TYPE */}
          {/* <div className="row-primary">
            <h2>Encounter Type *</h2>
            <Controller
              name="type"
              control={control}
              rules={{
                required: "Encounter type is required",
              }}
              render={({ field }) => (
                <div style={{ width: "100%" }}>
                  <Select
                    name="type"
                    options={encounterTypeOptions || []}
                    {...field}
                    value={
                      field.value
                        ? encounterTypeOptions?.find(
                            (opt) => opt.value == field.value
                          )
                        : ""
                    }
                    isClearable={false}
                  />

                  {errors?.type?.message && (
                    <div style={{ marginBottom: 10 }}>
                      <ErrorMessage text={errors?.type?.message} />
                    </div>
                  )}

                  {error?.errors?.type?.map((error) => (
                    <div style={{ marginBottom: 10 }}>
                      <ErrorMessage text={error} />
                    </div>
                  ))}
                </div>
              )}
            />
          </div> */}

          {/* ENCOUNTER SOURCE */}
          {/* <div className="row-primary">
            <h2>Encounter Source</h2>
            <Controller
              name="encounter_source"
              control={control}
              render={({ field }) => (
                <div style={{ width: "100%" }}>
                  <Select
                    name="encounter_source"
                    options={encounterSourceOptions || []}
                    {...field}
                    loading={loadingLanguage}
                    value={
                      field.value
                        ? encounterSourceOptions?.find(
                            (opt) => field.value == opt.value
                          )
                        : ""
                    }
                  />
                  {errors?.encounter_source?.message && (
                    <div style={{ marginBottom: 10 }}>
                      <ErrorMessage text={errors?.encounter_source?.message} />
                    </div>
                  )}
                  {error?.errors?.encounter_source?.map((error) => (
                    <div style={{ marginBottom: 10 }}>
                      <ErrorMessage text={error} />
                    </div>
                  ))}
                </div>
              )}
            />
          </div> */}

          {/* REQUESTER */}
          <div className="row-primary">
            <h2>Requestor First Name *</h2>
            <div className="w-100">
              <Controller
                name="requester_name"
                rules={{
                  required: "Requestor name is required",
                }}
                control={control}
                render={({ field }) => (
                  <input className="input-in type_inp" type="text" {...field} />
                )}
              />
              {errors?.requester_name?.message && (
                <div style={{ marginBottom: 10 }}>
                  <ErrorMessage text={errors?.requester_name?.message} />
                </div>
              )}
            </div>
          </div>

          {/* REQUESTOR PHONE NUMBER */}
          <div className="row-primary">
            <h2>Requestor Callback Number *</h2>
            <div className="w-100">
              <Controller
                name="requester_phone"
                control={control}
                rules={{
                  required: "Requestor callback number is required",
                }}
                render={({ field }) => (
                  <input
                    className="input-in type_inp"
                    type="tel"
                    name="requester_phone"
                    placeholder="Phone Number"
                    {...field}
                    onChange={(e) => {
                      if (e.target.value.length <= 20) {
                        field.onChange(e);
                      }
                    }}
                  />
                )}
              />

              {errors?.requester_phone?.message && (
                <div style={{ marginBottom: 10 }}>
                  <ErrorMessage text={errors?.requester_phone?.message} />
                </div>
              )}

              {error?.errors?.phone?.map((error) => (
                <div style={{ marginBottom: 10 }}>
                  <ErrorMessage text={error} />
                </div>
              ))}
            </div>
          </div>

          {/* REQUESTOR EMAIL */}
          <div className="row-primary">
            <h2>Requestor Email *</h2>
            <div className="w-100">
              <Controller
                name="requester_email"
                control={control}
                rules={{
                  validate: (emails, formValues) => {
                    // agar Encounter Type = "In Person" ho to required nahi hoga
                    if (formValues.type === "In Person") {
                      return true;
                    }

                    // normalize emails into array
                    let emailsArray = [];
                    if (typeof emails === "string") {
                      emailsArray = emails
                        .split(",")
                        .map((e) => e.trim())
                        .filter((e) => e.length > 0);
                    } else if (Array.isArray(emails)) {
                      emailsArray = emails;
                    }

                    // check empty
                    if (emailsArray.length === 0) {
                      return "At least one email is required";
                    }

                    // email regex
                    const emailPattern =
                      /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

                    // invalid check
                    const invalidEmails = emailsArray.filter(
                      (email) => !emailPattern.test(email)
                    );
                    if (invalidEmails.length > 0) {
                      return `Invalid email(s): ${invalidEmails.join(", ")}`;
                    }

                    return true;
                  },
                }}
                render={({ field }) => {
                  let emailsArray = [];

                  if (typeof field.value === "string") {
                    emailsArray = field.value
                      .split(",")
                      .map((email) => email.trim())
                      .filter((email) => email.length > 0);
                  } else if (Array.isArray(field.value)) {
                    emailsArray = field.value;
                  }

                  return (
                    <div>
                      <TagInput
                        value={emailsArray}
                        onChange={(newTags) => {
                          const newEmailsString = newTags.join(", ");
                          field.onChange(newEmailsString);
                        }}
                      />
                    </div>
                  );
                }}
              />

              {errors?.requester_email?.message && (
                <div style={{ marginBottom: 10 }}>
                  <ErrorMessage text={errors?.requester_email?.message} />
                </div>
              )}
            </div>
          </div>

          <div className="row-primary">
            <h2>Requestor Pin Code *</h2>
            <div className="w-100">
              <Controller
                name="requester_pin_code"
                rules={{
                  required: "Requestor pin code is required",
                }}
                control={control}
                render={({ field }) => (
                  <div style={{ width: "100%" }}>
                    <Select
                      menuPlacement="auto"
                      styles={{ ...selectCustomStyles }}
                      name="requester_pin_code"
                      options={pinCodeOptions || []}
                      {...field}
                      value={
                        field.value
                          ? pinCodeOptions?.find(
                              (opt) => opt.value == field.value
                            )
                          : ""
                      }
                    />
                    {errors?.requester_pin_code?.message && (
                      <div style={{ marginBottom: 10 }}>
                        <ErrorMessage text={errors?.requester_pin_code?.message} />
                      </div>
                    )}
                  </div>
                )}
              />
            </div>
          </div>





          <div className="row-primary">
            <h2>Economic services *</h2>
            <Controller
              name="economic_services"
              control={control}
              rules={{
                required: "Please select economic services",
              }}
              render={({ field }) => (
                <div style={{ width: "100%" }}>
                  <Select
                    name="economic_services"
                    options={economicServiceOptions || []}
                    {...field}
                    loading={loadingLanguage}
                    value={
                      field.value
                        ? economicServiceOptions?.find(
                            (opt) => field.value == opt.value
                          )
                        : ""
                    }
                  />
                  {errors?.economic_services?.message && (
                    <div style={{ marginBottom: 10 }}>
                      <ErrorMessage text={errors?.economic_services?.message} />
                    </div>
                  )}
                  {error?.errors?.economic_services?.map((error) => (
                    <div style={{ marginBottom: 10 }}>
                      <ErrorMessage text={error} />
                    </div>
                  ))}
                </div>
              )}
            />
          </div>

          {/* PROVIDER NAME */}
          {/* <div className="row-primary">
            <h2>Provider Name *</h2>
            <div className="w-100">
              <Controller
                name="provider_name"
                rules={{
                  required: "Provider name is required",
                }}
                control={control}
                render={({ field }) => (
                  <input className="input-in type_inp" type="text" {...field} />
                )}
              />
              {errors?.provider_name?.message && (
                <div style={{ marginBottom: 10 }}>
                  <ErrorMessage text={errors?.provider_name?.message} />
                </div>
              )}
            </div>
          </div> */}

          {/* VENDOR SELECT */}
          {/* {(!item?.id || isDuplicate) && (
            <div className="row-primary">
              <h2>Vendor</h2>
              <div className="w-100">
                <Controller
                  name="vendor_id"
                  control={control}
                  render={({ field }) => (
                    <div style={{ width: "100%" }}>
                      <AsyncPaginate
                        menuPlacement="auto"
                        styles={{
                          ...selectCustomStyles,
                        }}
                        isDisabled={isInterpreter} // Keep this for UI behavior
                        value={filterVendor}
                        loadOptions={filteredVendorLoadOptions}
                        isClearable
                        escapeClearsValue
                        onChange={(obj) => {
                          if (obj?.value) {
                            setFilterVendors(obj);
                            field.onChange(obj.value);
                          } else {
                            setFilterVendors(null);
                            field.onChange(null);
                          }
                        }}
                        additional={{
                          page: item?.state?.id ? 2 : 1,
                        }}
                      />
                    </div>
                  )}
                />
              </div>
            </div>
          )} */}

          {/* INTERPRETER SELECT */}
          {/* {(!item?.id || isDuplicate) && (
            <div className="row-primary">
              <h2>Interpreter</h2>
              <div className="w-100">
                <Controller
                  name="interpreter_id"
                  control={control}
                  render={({ field }) => (
                    <div style={{ width: "100%" }}>
                      <AsyncPaginate
                        menuPlacement="top"
                        styles={{
                          ...selectCustomStyles,
                        }}
                        isDisabled={isVendor}
                        value={filterInterpreters}
                        loadOptions={filteredInterpretersLoadOptions}
                        isClearable
                        escapeClearsValue
                        onChange={(obj) => {
                          if (obj?.value) {
                            setFilterInterpreters(obj);
                            field.onChange(obj.value);
                          } else {
                            setFilterInterpreters(null);
                            field.onChange(null);
                          }
                        }}
                        additional={{
                          page: item?.state?.id ? 2 : 1,
                        }}
                      />
                    </div>
                  )}
                />
              </div>
            </div>
          )} */}


          {/* SPECIAL INSTRUCTIONS */}
          <div className="row-primary">
            <h2>Notes</h2>
            <Controller
              name="special_instruction"
              control={control}
              render={({ field }) => (
                <textarea
                  className="type_inp input-in"
                  {...field}
                  placeholder="Notes"
                ></textarea>
              )}
            />
          </div>

          {/* {watch("interpreter_id") && (
            <CheckinCheckout apptAssign={item?.appointment_assign} />
          )} */}
          {watch("available_status") &&
            watch("interpreter_id") &&
            item?.appointment_assign?.interpreter_id && (
              <>
                <CheckinDateTimeInputs />
                <CheckoutDateTimeInputs />
                <CommentsAndNotes />
              </>
            )}
        </>

        {/* ERROR MESSAGES */}
        <>
          {Object.keys(errors)?.length > 0 && (
            <div className="row-primary align-center">
              <i class="fa-solid fa-circle-exclamation mt-2 error-color "></i>
              <ErrorMessage
                fontWeight={"bold"}
                text={"Please fill all mandatory fields"}
              />
            </div>
          )}

          {error?.errors?.billed?.map((error) => (
            <div style={{ marginBottom: 10 }}>
              <ErrorMessage text={error} />
            </div>
          ))}
          {error?.errors?.mrn_number?.map((error) => (
            <div style={{ marginBottom: 10 }}>
              <ErrorMessage text={error} />
            </div>
          ))}
          {error?.errors?.requestor_phone_num?.map((error) => (
            <div style={{ marginBottom: 10 }}>
              <ErrorMessage text={error} />
            </div>
          ))}
        </>

        <div className="Form-footer">
          <button
            type="button"
            className="Cancle_button"
            data-bs-dismiss={itsBootstrap ? "modal" : ""}
            onClick={handleClose}
          >
            Cancel
          </button>
          <SubmitButton
            btnText={item?.id && !isDuplicate ? "Update Request" : "Submit Request"}
            buttonType="button"
            handleSubmit={handleSubmit(onSubmit, onError)}
            loader={loaderState}
          />
        </div>
      </form>
    </FormProvider>
  );
};

export const CheckinCheckout = ({ apptAssign }) => {
  const { control, setValue, watch } = useFormContext();

  const interpreterId = watch("interpreter_id");

  useEffect(() => {
    if (interpreterId) {
      setValue(
        "comments",
        commentsTypeOptions[commentsTypeOptions?.length - 1].value
      );
    } else {
      setValue("comments", "");
    }
  }, [interpreterId]);

  useEffect(() => {
    if (apptAssign?.checkin_date) {
      setValue("available_status", true);
    }
  }, []);
  return (
    <>
      <div className="row-primary">
        {/* <h2>Add Check In / Check Out</h2> */}
        <Controller
          name="available_status"
          control={control}
          render={({ field }) => (
            <Checkbox
              title={"Add Check In / Check Out"}
              isChecked={!!apptAssign?.checkin_date && field?.value}
              handleCheck={field.onChange}
              value={field.value}
            />
          )}
        />
      </div>
    </>
  );
};

const DateTimeInputs = ({ isDuplicate, isNew }) => {
  const { control, formState, setValue, watch } = useFormContext();
  return (
    <div className="row-primary row-r">
      <div className="date">
        <h2>Date*</h2>
        <Controller
          name="date"
          control={control}
          rules={{
            required: "Please select date",
          }}
          render={({ field }) => (
            <div>
              <div className="input-image">
                <input
                  id="date"
                  type="date"
                  name="date"
                  placeholder="Date"
                  required
                  {...field}
                  value={field.value ? field.value : ""}
                  onChange={(e) => {
                    const dateString = e.target.value
                      ? moment.utc(e.target.value).format("YYYY-MM-DD")
                      : "";
                    field.onChange(dateString);

                    if (watch("available_status")) {
                      if (isDuplicate || isNew) {
                        setValue("checkin_date", watch("date"));
                        setValue("checkout_date", watch("date"));
                      }
                    }
                  }}
                />
                <img
                  src="/images/celender.png"
                  alt="celender Icon"
                  className="custom-icon"
                />
              </div>
              {formState?.errors?.date?.message && (
                <div style={{ marginBottom: 10 }}>
                  <ErrorMessage text={formState?.errors?.date?.message} />
                </div>
              )}
            </div>
          )}
        />
      </div>

      <div className="time">
        <h2>Time*</h2>
        <Controller
          name="start_time"
          control={control}
          rules={{
            required: "Please select start time",
          }}
          render={({ field }) => (
            <div>
              <div className="input-image">
                <input
                  type="time"
                  name="start_time"
                  placeholder="hh:mm"
                  {...field}
                  value={moment(field.value, ["h:mm A"]).format("HH:mm")}
                  onChange={(e) => {
                    // const timeString = moment.utc(e.target.value, ["HH:mm"]).format("HH:mm");
                    field.onChange(e.target.value);
                    if (watch("available_status")) {
                      if (isDuplicate || isNew) {
                        setValue("checkin_time", watch("start_time"));
                        // and checkout_time shoudld be 15 mins above start_time
                        const duraton = watch("duration");
                        const checkout_time = moment(e.target.value, ["HH:mm"])
                          .add(duraton, "minutes")
                          .format("HH:mm");
                        setValue("checkout_time", checkout_time);
                        // and checkout_date should be same as date
                      }
                    }
                  }}
                  // value={field.value}
                  required
                />
                <img
                  src="/images/clock.png"
                  alt="Clock Icon"
                  className="custom-icon"
                />
              </div>
              {formState?.errors?.start_time?.message && (
                <div style={{ marginBottom: 10 }}>
                  <ErrorMessage text={formState?.errors?.start_time?.message} />
                </div>
              )}
            </div>
          )}
        />
      </div>
    </div>
  );
};

const commentsTypeOptions = [
  { value: "Admission/Intake", label: "Admission/Intake" },
  { value: "Discharge", label: "Discharge" },
  { value: "Informed Consent", label: "Informed Consent" },
  { value: "Service Decline", label: "Service Decline" },
  { value: "Other", label: "Other" },
];

export const CheckinDateTimeInputs = () => {
  const {
    control,
    setValue,
    watch,
    formState: { errors },
    setError,
    clearErrors,
  } = useFormContext();
  const [dateChecked, setDateChecked] = useState(false);
  const [timeChecked, setTimeChecked] = useState(false);
  const [checkinTimeRequired, setCheckinTimeRequired] = useState(false);

  useEffect(() => {
    if (watch("checkin_date") && !watch("checkin_time")) {
      setError("checkin_time", {
        message: "Checkin time required",
      });
    } else {
      clearErrors("checkin_time");
    }
  }, [watch("checkin_date"), watch("checkin_time")]);

  return (
    <div className="row-primary flex-column gap-0 mb-0">
      <h2 className="fst-italic">Add Check In</h2>
      <div className="row-primary row-r">
        <div className="date">
          <h2>Date*</h2>
          <Controller
            name="checkin_date"
            control={control}
            render={({ field }) => (
              <div style={{ width: "100%" }}>
                <div className="input-image">
                  <input
                    id="date"
                    type="date"
                    name="checkin_date"
                    placeholder="Date"
                    required
                    {...field}
                    value={
                      field.value
                        ? moment(field.value).format("YYYY-MM-DD")
                        : ""
                    }
                    onChange={(e) => {
                      const dateString = e.target.value
                        ? moment.utc(e.target.value).format("YYYY-MM-DD")
                        : "";

                      field.onChange(dateString);
                      if (!dateString) {
                        setValue("checkin_time", "");
                      }
                    }}
                  />
                  <img
                    src="/images/celender.png"
                    alt="celender Icon"
                    className="custom-icon"
                  />
                </div>
                {/* <div className="mt-2 sub_check">
                  <Checkbox
                    title={"Set Current Date"}
                    handleCheck={
                      (e) => {
                        if (e.target.checked) {
                          const currentDate = moment().format('YYYY-MM-DD')
                          setValue("checkin_date", currentDate)
                        }
                        else {
                          setValue("checkin_date", "")
                        }
                      }
                    }
                  />
                </div> */}
              </div>
            )}
          />
        </div>

        <div className="time">
          <h2>Time*</h2>
          <Controller
            name="checkin_time"
            control={control}
            render={({ field }) => (
              <div style={{ width: "100%" }}>
                <div className="input-image">
                  <input
                    type="time"
                    name="checkin_time"
                    placeholder="hh:mm"
                    {...field}
                    // value={moment(field.value, ["h:mm A"]).format("HH:mm")}
                    // value={field.value}
                    required
                  />
                  <img
                    src="/images/clock.png"
                    alt="Clock Icon"
                    className="custom-icon"
                  />
                </div>

                {errors?.checkin_time?.message && (
                  <div style={{ marginBottom: 10 }}>
                    <ErrorMessage text={errors?.checkin_time?.message} />
                  </div>
                )}
                {/* <div className="mt-2 sub_check">
                  <Checkbox
                    title={"Set Current Time"}
                    handleCheck={
                      (e) => {
                        if (e.target.checked) {
                          const currentTime = moment().format('HH:mm')
                          setValue("checkin_time", currentTime)
                        }
                        else {
                          setValue("checkin_time", "")
                        }
                      }
                    }
                  />
                </div> */}
              </div>
            )}
          />
        </div>
      </div>
    </div>
  );
};

export const CheckoutDateTimeInputs = () => {
  const {
    control,
    setValue,
    watch,
    formState: { errors },
    setError,
    clearErrors,
  } = useFormContext();
  const [checkoutTimeRequired, setCheckoutTimeRequired] = useState(false);

  useEffect(() => {
    if (watch("checkout_date") && !watch("checkout_time")) {
      setError("checkout_time", {
        message: "Checkout time required",
      });
    } else {
      clearErrors("checkout_time");
    }
  }, [watch("checkout_date"), watch("checkout_time")]);

  return (
    <div className="row-primary flex-column gap-0 mb-0">
      <h2 className="fst-italic">Add Check Out</h2>
      <div className="row-primary row-r">
        <div className="date">
          <h2>Date</h2>
          <Controller
            name="checkout_date"
            control={control}
            render={({ field }) => (
              <div style={{ width: "100%" }}>
                <div className="input-image">
                  <input
                    id="date"
                    type="date"
                    name="checkout_date"
                    placeholder="Date"
                    required
                    {...field}
                    value={
                      field.value
                        ? moment(field.value).format("YYYY-MM-DD")
                        : ""
                    }
                    onChange={(e) => {
                      if (e.target.value) {
                        const dateString = moment
                          .utc(e.target.value)
                          .format("YYYY-MM-DD");
                        field.onChange(dateString);

                        if (!dateString) {
                          setValue("checkout_time", "");
                        }
                      } else {
                        field.onChange("");
                        setValue("checkout_time", "");
                      }
                    }}
                  />
                  <img
                    src="/images/celender.png"
                    alt="celender Icon"
                    className="custom-icon"
                  />
                </div>
                {/* <div className="mt-2 sub_check">
                  <Checkbox
                    title={"Set Checkout Date"}
                    handleCheck={
                      (e) => {
                        if (e.target.checked) {
                          const currentDate = moment().format('YYYY-MM-DD')
                          setValue("checkout_date", currentDate)
                        }
                        else {
                          setValue("checkout_date", "")
                        }
                      }
                    }
                  />
                </div> */}
              </div>
            )}
          />
        </div>

        <div className="time">
          <h2>Time</h2>
          <Controller
            name="checkout_time"
            control={control}
            render={({ field }) => (
              <div style={{ width: "100%" }}>
                <div className="input-image">
                  <input
                    type="time"
                    name="checkout_time"
                    placeholder="hh:mm"
                    {...field}
                    // value={moment(field.value, ["h:mm A"]).format("HH:mm")}
                    // value={field.value}
                    required
                  />
                  <img
                    src="/images/clock.png"
                    alt="Clock Icon"
                    className="custom-icon"
                  />
                </div>

                {errors?.checkout_time?.message && (
                  <div style={{ margoutBottom: 10 }}>
                    <ErrorMessage text={errors?.checkout_time?.message} />
                  </div>
                )}
                {/* <div className="mt-2 sub_check">
                  <Checkbox
                    title={"Set Checkout Time"}
                    handleCheck={
                      (e) => {
                        if (e.target.checked) {
                          const currentTime = moment().add(15, 'minutes').format('HH:mm')
                          setValue("checkout_time", currentTime)
                        }
                        else {
                          setValue("checkout_time", "")
                        }
                      }
                    }
                  />
                </div> */}
              </div>
            )}
          />
        </div>
      </div>
    </div>
  );
};

export const CommentsAndNotes = () => {
  const { control, setValue, watch } = useFormContext();

  useEffect(() => {
    if (watch("interpreter_id"))
      setValue(
        "comments",
        commentsTypeOptions[commentsTypeOptions?.length - 1].value
      );
    else setValue("comments", "");
  }, [watch("interpreter_id")]);

  return (
    <>
      <div className="row-primary">
        <h2>Comments</h2>
        <Controller
          name="comments"
          control={control}
          render={({ field }) => (
            <Select
              name="comments"
              options={commentsTypeOptions || []}
              {...field}
              value={
                field.value
                  ? commentsTypeOptions?.find((opt) => field.value == opt.value)
                  : ""
              }
              onChange={field.onChange}
            />
          )}
        />
        {/* <p className="error">{field.error?.message}</p> */}
      </div>
      <div className="row-primary">
        <h2>Notes</h2>

        <Controller
          name="notes"
          control={control}
          render={({ field }) => (
            <textarea
              className="input-in type_inp"
              type="text"
              name="notes"
              placeholder="Enter notes and additional comments"
              {...control}
              {...field}
            />
          )}
        />
      </div>
    </>
  );
};

export const DurationRange = ({ control }) => {
  return (
    <div className="row-primary mt-5 mtSm_0">
      <h2>Duration 1 mins.</h2>
      <div className="w-100">
        <label for="customRange1" className="form-label"></label>
        <Controller
          name="duration"
          control={control}
          render={({ field }) => (
            <Slider
              min={5}
              max={480}
              defaultValue={15}
              step={5}
              aria-label="Small"
              valueLabelDisplay="on"
              valueLabelFormat={(value) => `${value} mins`}
              sx={{
                color: "#6F8DFF",
                "& .MuiSlider-valueLabel": {
                  backgroundColor: "#6F8DFF",
                  color: "#FFFFFF",
                },
              }}
              value={field.value}
              onChange={(event, value) => field.onChange(value)}
            />
          )}
        />
      </div>
    </div>
  );
};

const PriorityLevel = ({ control, errors }) => {
  return (
    <>
      <div className="row-primary">
        <h2>Priority Level</h2>
        <div className="radio_row">
          <Controller
            name="priority_level"
            control={control}
            // rules={{
            //   required: "Please select an Option"
            // }}
            render={({ field }) => {
              return priorityLevelOptions?.map((opt) => (
                <div className="form-check-f">
                  <input
                    className="form-check-input-f"
                    type="radio"
                    name={"priority_level"}
                    id={opt.value}
                    checked={field.value === opt.value}
                    value={opt.value}
                    onChange={(e) => field.onChange(e.target.value)}
                    // {...field}
                  />
                  <label className="form-check-label-f" htmlFor={opt.value}>
                    {opt.label}
                  </label>
                </div>
              ));
            }}
          />
        </div>
      </div>

      {errors?.facilities?.message && (
        <div className="mt-4">
          <ErrorMessage text={errors?.option?.message} />
        </div>
      )}
    </>
  );
};

const JobTypes = ({ control, errors }) => {
  return (
    <>
      <div className="row-primary">
        <h2>Job Type</h2>
        <div className="radio_row">
          <Controller
            name="job_type"
            control={control}
            render={({ field }) => {
              return jobTypesOptions?.map((opt) => (
                <div className="form-check-f">
                  <input
                    className="form-check-input-f"
                    type="radio"
                    name={"job_type"}
                    id={opt.value}
                    checked={field.value === opt.value}
                    value={opt.value}
                    onChange={(e) => field.onChange(e.target.value)}
                  />
                  <label className="form-check-label-f" htmlFor={opt.value}>
                    {opt.label}
                  </label>
                </div>
              ));
            }}
          />
        </div>
      </div>

      {errors?.facilities?.message && (
        <div className="mt-4">
          <ErrorMessage text={errors?.option?.message} />
        </div>
      )}
    </>
  );
};

export default ClientScheduleForm;